import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import logger from "../../../util/logger";
import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent } from "../../../wayin-react";
import { wrapDisplayName } from 'react-recompose';
var SUPPORTED_STYLES = ['padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'fontSize', // needed for <Hoverable>
'transition', 'WebkitTransition', 'MozTransition', 'OTransition', 'transform', 'WebkitTransform', 'MozTransform', 'msTransform', 'OTransform'];

var whitelistStyles = function whitelistStyles(customSupported) {
  if (customSupported === void 0) {
    customSupported = [];
  }

  return function (Component) {
    return createComponent({
      displayName: wrapDisplayName(Component, 'whitelistStyles'),
      render: function render(props) {
        var passedStyles = _reduceInstanceProperty(_).call(_, props.style, function (acc, value, style) {
          if (!_includesInstanceProperty(_).call(_, _concatInstanceProperty(SUPPORTED_STYLES).call(SUPPORTED_STYLES, customSupported), style) && undefined) {
            logger.warn("Unsupported style override supplied to " + Component.displayName + ": " + style);
          } else {
            acc[style] = value;
          }

          return acc;
        }, {});

        var updatedProps = _Object$assign({}, props, {
          style: passedStyles
        });

        return /*#__PURE__*/React.createElement(Component, updatedProps);
      }
    });
  };
};

export default whitelistStyles;
//# sourceMappingURL=whitelist-styles.js.map